import React from "react";
import { useNavigate } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import { useZoneRetrieval } from "@planzone/view-models";
import { events } from "@planzone/events";
import {
  ZoneProjectsRetrievalFilter,
  zoneProjectsRetrievalFilter,
} from "@planzone/dto";

import { WorkspaceContext } from "@scenes/workspaceContext";
import { useMessage } from "@components/useMessage";
import { Notifications } from "@scenes/notifications";
import { AssistantShortcut } from "@scenes/assistantShortcut";
import { ProfileNavigation } from "@common/profileNavigation";
import { ZonesIcon } from "@common/layout/navigation/zonesIcon";
import { Navigation } from "./navigation";
import { ProjectsPage } from "./projectsPage";
import { GanttPage } from "./ganttPage";
import { Menu } from "./menu";
import { ReportsPage } from "./reportsPage";
import { WbsPage } from "./wbsPage";
import { WorkLoadsPage } from "./workLoadsPage";
import { ZoneCalendarPage } from "./calendarPage";
import { ToggleArrow } from "./toggleArrow";
import { Props } from "./types";
import styles from "./styles.scss";

function ZonePage(props: Props) {
  const navigate = useNavigate();
  const { zone: retrievedZone, retrieveZone } = useZoneRetrieval();
  const zone = { ...retrievedZone, uuid: retrievedZone.uuid || props.zoneId };
  const [filter, editFilter] = React.useState<ZoneProjectsRetrievalFilter>({
    ...zoneProjectsRetrievalFilter,
    limit: 999999,
    isSortedAlphabetically: true,
  });

  React.useEffect(() => {
    !!props.zoneId && retrieveZone({ ...zone, uuid: props.zoneId });
  }, [props.zoneId]);

  useMessage(
    (message) =>
      message.type === events.removeZoneSucceeded &&
      navigate("/zones", { replace: true }),
  );

  return (
    <WorkspaceContext type="zone" zone={zone}>
      <div className={styles.zonePage}>
        <div className={styles.header}>
          <div className={styles.subHeader}>
            <div className={styles.zone}>
              <div className={styles.backButton}>
                <ZonesIcon className={styles.zonesIcon} />
              </div>
              <ToggleArrow className={styles.separatorArrow} />
              <div className={styles.menu}>
                <Menu zone={zone} />
              </div>
            </div>
            <Navigation zone={zone} />
            <div className={styles.profileNavigation}>
              <AssistantShortcut />
              <Notifications />
              <ProfileNavigation />
            </div>
          </div>
        </div>
        <div className={styles.main}>
          <Routes>
            <Route
              path="projects"
              element={<ProjectsPage zone={zone} filter={filter} />}
            />
            <Route path="gantt" element={<GanttPage zone={zone} />} />
            <Route path="reports" element={<ReportsPage zone={zone} />} />
            <Route path="lists" element={<WbsPage zone={zone} />} />
            <Route path="workLoads" element={<WorkLoadsPage zone={zone} />} />
            <Route path="calendar" element={<ZoneCalendarPage zone={zone} />} />
            <Route
              path="*"
              element={<ProjectsPage filter={filter} zone={zone} />}
            />
          </Routes>
        </div>
      </div>
    </WorkspaceContext>
  );
}

export { ZonePage };
